import { useSelector, useDispatch } from 'react-redux'

import { clearTenantSummary } from 'slices/dashboardSlice'
import { selectSessionStatus, sessionClear, logout as sessionLogout } from 'slices/sessionSlice'
import { clearWorkspaceList } from 'slices/workspacesSlice'

// ログアウト時は必ずこのフックを使用する

const useLogout = () => {
  const { isTokenInvalid } = useSelector(selectSessionStatus)
  const dispatch = useDispatch()
  const logout = () => {
    // セッションが無効な場合はAPIを叩かずにストアをクリアするだけにする
    isTokenInvalid ? dispatch(sessionClear()) : dispatch(sessionLogout())
    dispatch(clearTenantSummary())
    dispatch(clearWorkspaceList())
  }
  return { logout }
}
export default useLogout
